
export const category =  ["Learn" ,"Nutrition & Diet" , "Exercise & Fitness" , "Emotional Health & Wellness" , "Immediate Help"]